var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShieldCheck = function SvgShieldCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.231 4.71a1.5 1.5 0 0 1 1.764.167 22.5 22.5 0 0 0 15.937 5.625l.254.01a1.5 1.5 0 0 1 1.254 1.064 25.5 25.5 0 0 1-.191 15.004 1.5 1.5 0 1 1-2.855-.92 22.5 22.5 0 0 0 .456-12.137A25.5 25.5 0 0 1 24 7.955a25.5 25.5 0 0 1-15.854 5.568A22.5 22.5 0 0 0 23.364 40.26a1.5 1.5 0 1 1-.889 2.865A25.5 25.5 0 0 1 5.561 11.576a1.5 1.5 0 0 1 1.508-1.074 22.5 22.5 0 0 0 15.938-5.625z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M40.94 32.94a1.5 1.5 0 0 1 2.12 2.12l-8 8a1.5 1.5 0 0 1-2.12 0l-4-4a1.5 1.5 0 0 1 2.12-2.12L34 39.878z"
  })));
};
export default SvgShieldCheck;